import {
  GenerateAsOption,
  GroupByOption,
  PeoplePageSourceDerivedQuestionSectionAttributes,
} from 'api/custom-section/types';
import { SourcePageTemplate } from 'api/custom-section/types';
import { CustomSectionComponentProps } from '../../../types';

export type PeoplePageSourceDerivedQuestionSectionComponentProps =
  CustomSectionComponentProps<PeoplePageSourceDerivedQuestionSectionAttributes>;
export type PromptInputFormValues = {
  title: string;
  question: string;
  aiContextChecked: boolean;
  aiContext: string;
  groupBy: GroupByOption;
  generateAs: GenerateAsOption;
  sourcePageTemplates: SourcePageTemplate[];
};
export type Configuration = {
  groupBy: GroupByOption;
  generateAs: GenerateAsOption;
  sourcePageTemplates: SourcePageTemplate[];
};

export const defaultConfiguration: Configuration = {
  groupBy: GroupByOption.Topics,
  generateAs: GenerateAsOption.Bullet,
  sourcePageTemplates: [],
};
